module.exports = __webpack_public_path__ + "media/promo/advent/images/cells/cell-30-343c03332f739b637a656ec4300ff79a.png";